import PropTypes from "prop-types";
import Button from "@shared/v2/Button";
import Modal from "@shared/v2/Modal";
import Typography from "@shared/v2/Typography";
import TextLink from "@shared/v2/TextLink";

const NoSeatsRemainingModal = ({ show, onClose }) => (
  <Modal
    show={show}
    onHide={onClose}
    dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
    contentClassName="tw-max-w-[440px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
  >
    <Modal.Header title="No Seats Remaining" closeButton />
    <Modal.Body className="tw-flex tw-flex-col tw-gap-[24px]">
      <Typography variant="body-m">
        You already have the maximum amount of seated users allowed on your account.
      </Typography>

      <Typography variant="body-m">
        You can either archive a current user from the{" "}
        <TextLink href="/account" target="_blank">
          users page
        </TextLink>{" "}
        or chat with support to purchase more seats.
      </Typography>
    </Modal.Body>
    <Modal.Footer className="tw-flex tw-justify-between tw-gap-[16px]">
      <Button size="medium" schema="tertiary" onClick={onClose}>
        Cancel
      </Button>
      <Button size="medium" onClick={onClose}>
        Got It
      </Button>
    </Modal.Footer>
  </Modal>
);

NoSeatsRemainingModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default NoSeatsRemainingModal;
